import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_HOTEL,
	STR_HOTEL_MENU,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_HOTELS,
	STR_MY_STUDENTS,
	STR_NO_PERMISSION,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_REVENUE,
	STR_REVENUE_AND_WITHDRAWALS,
	STR_ROOM_BOOKINGS,
	STR_ROOMS,
	STR_SET_CURRENCY,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP,
	STR_REPORTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdDashboard, MdInfoOutline, MdList, MdLogout, MdManageAccounts, MdMoney, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWarning, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import WelcomeSlider from "../ones/WelcomeSlider";
import { RiHotelLine } from "react-icons/ri";
import { HiDocumentText, HiArrowDownTray, HiChartBar } from "react-icons/hi2";

export default function View({ hotelId }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [hotelData,  setHotelData] = useState(null);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
			getHotelData(),
		])
		setReady(true);
	}

	async function getHotelData() {
		await callApi('get-current-hotel-data', { id: hotelId }).then((response) => {
			if(response.status === 1) {
				setHotelData(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	
	useEffect(() => {
		init();
	}, [])



	if (ready && hotelData) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						{
							(Number(appContext.currentUserData.id) === Number(hotelData.managerId)) ?
							<div className="col-md-12">
								<div className="card mb-5">
									<div className="card-body text-center">
										
										<h6
											className="text-primary font-light mt-3 mb-3"
											style={{
												fontSize: "28px"
											}}
										>
											{hotelData.name}
										</h6>

										<span className="badge bg-secondary">{STR_HOTEL[appContext.language]}</span>
									</div>
								</div>

								<h6 className="main-section-title">
									{STR_HOTEL_MENU[appContext.language]}
								</h6>

								<div className="row mt-3 mb-3">
									<div 
										className="col-6 text-center"
										onClick={() => {
											appContext.navTo({
												item: 'manage-hotel',
												subItem: hotelId,
												extraItem: 'revenue_withdrawals'
											})
										}}
									>
										<MdMoney size={32}/>
										<h6
											style={{
												fontSize: "12px",
											}}
											className="font-semi-bold"
										>
											{STR_REVENUE_AND_WITHDRAWALS[appContext.language]}
										</h6>
									</div>

									<div 
										className="col-6 text-center"
										onClick={() => {
											appContext.navTo({
												item: 'manage-hotel',
												subItem: hotelId,
												extraItem: 'room_orders'
											})
										}}
									>
										<MdList size={32}/>
										<h6
											style={{
												fontSize: "12px",
											}}
											className="font-semi-bold"
										>
											{STR_ROOM_BOOKINGS[appContext.language]}
										</h6>
									</div>

									<div 
										className="col-6 text-center mt-3"
										onClick={() => {
											appContext.navTo({
												item: 'manage-hotel',
												subItem: hotelId,
												extraItem: 'all_rooms'
											})
										}}
									>
										<MdDashboard size={32}/>
										<h6
											style={{
												fontSize: "12px",
											}}
											className="font-semi-bold"
										>
											{STR_ROOMS[appContext.language]}
										</h6>
									</div>

									<div 
										className="col-6 text-center mt-3"
										onClick={() => {
											appContext.navTo({
												item: 'manage-hotel',
												subItem: hotelId,
												extraItem: 'report'
											})
										}}
									>
										<HiDocumentText size={32}/>
										<h6
											style={{
												fontSize: "12px",
											}}
											className="font-semi-bold"
										>
											{STR_REPORTS[appContext.language]}
										</h6>
									</div>

								</div>

								<hr/>
							</div>
							:
							<div className="col-md-12">
								<div className="card">
									<div className="card-body text-center">
										<MdWarning size={56} className="text-secondary"/>

										<h6
											style={{
												fontSize: "22px"
											}}
											className="font-semi-bold"
										>
											{STR_NO_PERMISSION[appContext.language]}
										</h6>
									</div>
								</div>
							</div>
						}
					 

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}